import InstructorHeader from "../components/instructorHeader";
import josh from "../assets/images/team/josh.svg";
import topTea from "../assets/images/team/shally.svg";
import gladys from "../assets/images/team/gladys.svg";
import lesh from "../assets/images/team/lesh.svg";
import issues from "../assets/images/team/issues.svg";
import Announcement from "../components/announcement";
import Wrapper from "./wrapper";
import { useEffect, useState } from "react";
import { getInstructors } from "../lib/firestoreContent";

const fallbackInstructorImages = {
  "Olubowale Gladys Opeoluwa": gladys,
  "Olubowale Gladys": gladys,
  "Joshua Momo": josh,
  "Joshua Wisdom Momo": josh,
  "Lesh Tayo": lesh,
  "Ekundayo Shallom": topTea,
  "Iseoluwa Gbotemi": issues,
};

// Shown until the admin dashboard publishes instructors to Firestore (keeps the page from ever being empty).
const fallbackInstructors = [
  { id: "fallback-1", name: "Olubowale Gladys Opeoluwa", role: "Founder and CEO", bio: "Chemical Engineering and Mastercard Foundation scholar, University of Toronto, Canada Research Project Management Process Engineering Intern, Vale Ltd Canada", imageUrl: gladys },
  { id: "fallback-2", name: "Joshua Momo", role: "Operations Director/Program Director", bio: "Graduate Student in the MS Engineering AI program at CMU-Africa", imageUrl: josh },
  { id: "fallback-3", name: "Lesh Tayo", role: "UI/UX designer", bio: "Computer science student at Ekiti State University, Nigeria", imageUrl: lesh },
  { id: "fallback-4", name: "Ekundayo Shallom", role: "Developer", bio: "Computer science student at Univeristy of Jos, Nigeria", imageUrl: topTea },
  { id: "fallback-5", name: "Iseoluwa Gbotemi", role: "Developer", bio: "Computer science student at Univeristy of Toronto", imageUrl: issues },
];

const Instructors = () => {
  const [instructors, setInstructors] = useState(fallbackInstructors);
  const [instructorsState, setInstructorsState] = useState({ loading: true, error: "" });

  useEffect(() => {
    const loadInstructors = async () => {
      try {
        const items = await getInstructors();
        if (items.length > 0) {
          setInstructors(items);
        }
        setInstructorsState({ loading: false, error: "" });
      } catch (error) {
        console.error("Unable to load instructors:", error);
        setInstructorsState({ loading: false, error: "Unable to load the latest instructor list." });
      }
    };

    loadInstructors();
  }, []);

  return (
    <>
      <div className="px-[30px] md:px-[139px]">
        <div>
          <Wrapper>
            <InstructorHeader />
          </Wrapper>
          <Announcement />
        </div>
        <h1
          style={{
            fontFamily: "'Clash Display', sans-serif",
          }}
          className="text-center text-[2.3rem] m-[auto]   font-bold text-dark"
        >
          Meet the Instructors
        </h1>
        {instructorsState.error && (
          <p className="text-center text-red-600 mt-4">{instructorsState.error}</p>
        )}
        <div className=" grid grid-cols-12 gap-2 md:gap-15">
          {instructors.map((instructor) => {
            const photoUrl = instructor.imageUrl || instructor.photoUrl || fallbackInstructorImages[instructor.name] || gladys;
            return (
              <div
                key={instructor.id}
                style={{
                  fontFamily: "'Montserrat', sans-serif",
                }}
                className="col-span-12 md:col-span-4 m-auto shadow-xl mt-[30px] mb-[30px] text-center rounded-lg p-[30px] "
              >
                {photoUrl && <img className="m-auto rounded-full w-28 h-28 object-cover shadow-sm bg-purple-50" src={photoUrl} alt={instructor.name} />}
                <p className=" text-center text-[black] font-bold mt-3">{instructor.name}</p>
                <p className=" text-center text-[#9D9898] ">{instructor.role}</p>
                {instructor.bio && (
                  <p className=" text-center text-[#9D9898] text-[0.9rem] mt-[10px] ">{instructor.bio}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Instructors;
